export default __webpack_public_path__ + "static/media/il_proceso.c0d46d6f.svg";